import { IAppState } from '../../../../shared/common/state';

export const selectIsUserAgent = (state: IAppState) => {
  const { user } = state;
  const availableUserTypes = [
    'realtor_not_commerce',
    'realtor_based',
    'realtor_prof',
    'agency',
    'official_representative_agency',
  ];

  if (!user.isAuthenticated) {
    return false;
  } else {
    const isAgent = user.userType && availableUserTypes.includes(user.userType);
    const isSubagent = user.userType === 'other' && user.isAgent;

    return Boolean(isAgent || isSubagent);
  }
};
